import { render } from "./TrackingOtp.vue?vue&type=template&id=81b61246"
import script from "./TrackingOtp.vue?vue&type=script&lang=js"
export * from "./TrackingOtp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__